import dayjs from "dayjs";

/**
 * Amount for the month `monthsAgo` before `today`, or undefined if none.
 * Server sends depletion.month as a "YYYYMM" string.
 * @param {{month: string, amount: number}[] | undefined} depletions
 * @param {number} monthsAgo
 * @param {import("dayjs").Dayjs} [today]
 * @returns {number | undefined}
 */
export const findMonthlyDepletionAmount = (depletions, monthsAgo, today = dayjs()) =>
    depletions?.find((d) => d.month === today.subtract(monthsAgo, "month").format("YYYYMM"))?.amount;
